/* ng-infinite-scroll - v1.0.0 - 2013-02-23 */
let mod;

mod = angular.module('infinite-scrollfork', []);

mod.directive('infiniteScrollfork', [
  '$rootScope', '$window', '$timeout', function ($rootScope, $window, $timeout) {
    return {
      link: function (scope, elem, attrs) {
        let checkWhenEnabled, handler, scrollDistance, scrollEnabled;
        $window = angular.element($window);
        scrollDistance = 0;
        if (attrs.infiniteScrollDistance != null) {
          scope.$watch(attrs.infiniteScrollDistance, function (value) {
            return scrollDistance = parseInt(value, 10);
          });
        }
        scrollEnabled = true;
        checkWhenEnabled = false;
        if (attrs.infiniteScrollDisabled != null) {
          scope.$watch(attrs.infiniteScrollDisabled, function (value) {
            scrollEnabled = !value;
            if (scrollEnabled && checkWhenEnabled) {
              checkWhenEnabled = false;
              return $timeout(handler);
            }
          });
        }
        handler = function () {
          let elementBottom = elem.prop('scrollHeight');
          let position = elem.scrollTop() + elem.height();
          let remaining = elementBottom - position;
          let shouldScroll = remaining <= elem.height() * scrollDistance;
          if (shouldScroll && scrollEnabled) {
            if ($rootScope.$$phase) {
              return scope.$eval(attrs.infiniteScrollfork);
            } else {
              return scope.$apply(attrs.infiniteScrollfork);
            }
          } else if (shouldScroll) {
            return checkWhenEnabled = true;
          }
        };
        elem.on('scroll', handler);
        scope.$on('$destroy', function () {
          return elem.off('scroll', handler);
        });
        return $timeout((function () {
          if (attrs.infiniteScrollImmediateCheck) {
            if (scope.$eval(attrs.infiniteScrollImmediateCheck)) {
              return handler();
            }
          } else {
            return handler();
          }
        }), 0);
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/lib/ng-infinite-scroll-fork.js